import styled from 'styled-components';
import { Dropdown as SemanticDropdown, Input as SemanticInput } from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  max-width: 100%;
  gap: 16px;
  margin-bottom: 16px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Dropdown = styled(SemanticDropdown)``;
export const Input = styled(SemanticInput)``;
